import { render, staticRenderFns } from "./advertisementList.vue?vue&type=template&id=029ba8f0&scoped=true"
import script from "./advertisementList.vue?vue&type=script&lang=js"
export * from "./advertisementList.vue?vue&type=script&lang=js"
import style0 from "./advertisementList.vue?vue&type=style&index=0&id=029ba8f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029ba8f0",
  null
  
)

export default component.exports